import EffectParameterSlider from './EffectParameterSlider.js';
import React, { Component } from 'react';

class WetSlider extends Component {
    render() {
        return (
            <EffectParameterSlider
              effectNumber={this.props.effectNumber}
              automation={this.props.automation}
              selectedParameter={this.props.selectedParameter}
              sequencerEngine={this.props.sequencerEngine}
              name='Wet'
              parameter={this.props.effect.wetParameter}
              lfoEnabled={true}
              onParameterChanged={this.props.onParameterChanged}
              isParameter={true}
              displayFunction={(wet) => Math.floor(wet*100)}
              unit="%"
              step={0.01}
              max={1}
              min={0}
              />
        );
    }
}

export default WetSlider;
